var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('span',{staticClass:"fas fa-times header__dropdown-close",on:{"click":function($event){return _vm.close()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }